import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { IconButton, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Button from "@mui/material/Button";
import { withRouter } from "react-router";
import { withSnackbar } from "notistack";
import Modal from "@mui/material/Modal";
import { RotateSpinner } from "react-spinners-kit";
import { useHistory } from "react-router";
import { v4 as uuidv4 } from "uuid";
import ReactTooltip from "react-tooltip";

import Report from "./report";
import Loader from "../components/common/Loader";
import QCModal from "../components/features/modals/qc-modal";
import SearchFilter from "../components/common/SearchFilter";
import WorkListStatusFilter from "../components/features/worklist-status-filter";
import WorklistFlag from "../components/worklistFlag";

import {
  getPatientByIdNum,
  getWorklist,
  updateStudy,
  getbillingInfo,
  writeModalityFile,
} from "../api/api";
import { ROWS_PER_PAGE, WORKLIST_COLUMN_PROPERTIES } from "../utils/constants";

import PersonIcon from "@mui/icons-material/Person";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { useNewPatientContext } from "../store/NewPatientContextProvider";
import { setNewPatient } from "../store/action-reducers";
import { useAuthUser } from "../store/AuthUserContextProvider";
import StudyCancelationForm from "../components/features/forms/study-cancelation";
import { useInterval } from "react-interval-hook";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Worklist = (props) => {
  const [worklist, setWorklist] = useState({
    list: [],
    filtered: [],
  });
  const [currentProcedure, setCurrentProcedure] = useState({
    index: null,
    data: null,
    isFor: null,
  });
  const [filter, setFilter] = useState({
    date: {
      start: null,
      end: null,
    },
    string: "",
    statusValues: [],
  });
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [openReport, setOpenReport] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [openIssues, setOpenIssues] = useState(false);
  const [Issues, setIssues] = useState(false);
  const [cancelationDetails, setCancelationDetails] = useState({
    Username: "",
    Password: "",
    Reason: "",
  });
  const { authUser } = useAuthUser();
  const FILTER_APPLIED = filter.string || filter.statusValues.length;
  const ALLOW_WORKLIST_DATA_UPDATE = !Boolean(
    currentProcedure.isFor === "PROCEDURE_CANCELATION" ||
      openReport ||
      loading ||
      (currentProcedure.data && currentProcedure.isFor === "QC") ||
      currentProcedure.isFor === "EDIT-PATIENT" ||
      FILTER_APPLIED
  );

  const getWorklistData = async () => {
    const ON_MY_WORKLIST = Boolean(window.location.pathname === "/my-worklist");

    if (ON_MY_WORKLIST) document.title = "My Worklist";
    else document.title = "Global Worklist";
    const [results, error] = await getbillingInfo("/billing");
    if (results) {
      console.log("results", results);
    } else {
      console.error(err.message);
      props.enqueueSnackbar(`ERROR: ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
    const [res, err] = await getWorklist(
      ON_MY_WORKLIST ? `/worklist/${authUser.Role}` : `/worklist/admin`
    );
    if (res) {
      console.log("worklist update");
      setWorklist({
        list: res.data,
        filtered: res.data,
      });

      setLoading(false);
    } else {
      setLoading(false);
      console.error(err.message);
      props.enqueueSnackbar(`ERROR: ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getWorklistData();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("enable-edit-user")) {
      localStorage.setItem("enable-edit-user", "");
    } else if (currentProcedure.isFor === "REPORT") {
      handleOpenReport();
    }
  }, [currentProcedure]);

  useEffect(() => {
    let filteredWorklist = worklist.list;
    if (FILTER_APPLIED) {
      filteredWorklist = FILTER_APPLIED
        ? getFilteredWorklist(filter.string, worklist.list)
        : filteredWorklist;

      if (filter.statusValues.length > 0) {
        let temp_worklist_data = [];

        filter.statusValues.map((value) => {
          temp_worklist_data.push.apply(
            temp_worklist_data,
            getFilteredWorklistByStatus(value, filteredWorklist)
          );
        });

        filteredWorklist = temp_worklist_data;
      }

      setWorklist({
        ...worklist,
        filtered: filteredWorklist,
      });
    } else {
      setWorklist({
        ...worklist,
        filtered: worklist.list,
      });
    }
  }, [filter]);

  useInterval(
    () => {
      if (ALLOW_WORKLIST_DATA_UPDATE) {
        getWorklistData();
        console.log("fething new tings");
      }
    },
    15000,
    {
      immediate: false,
    }
  );

  const handleCancelationDetailsChange = (e) => {
    setCancelationDetails({
      ...cancelationDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleStudyCancelationFormOpen = (index) => {
    const worklist_copy = [...worklist.filtered];
    const row = worklist_copy[index];
    setCurrentProcedure({
      index: index,
      data: row,
      isFor: "PROCEDURE_CANCELATION",
    });
  };


  const cleanOutCurrentProcedure = () => {
    setCurrentProcedure({
      index: null,
      isFor: null,
      data: null,
    });
  };

  const handleCancelProcedure = async () => {
    setLoading(true);

    const worklist_copy = [...worklist.filtered];
    worklist_copy[currentProcedure.index] = {
      ...currentProcedure.data,
      Canceled: true,
      CancelationReason: cancelationDetails.Reason,
    };

    const [res, err] = await updateStudy(worklist_copy[currentProcedure.index]);

    if (res) {
      setWorklist({
        list: worklist_copy,
        filtered: worklist_copy,
      });
    } else {
      console.error(err.message);
      props.enqueueSnackbar(`ERROR : ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
    cleanOutCurrentProcedure();
    setLoading(false);
  };

  const sendModalityFile = async (data) => {
    console.log("data", data);
    const [patientData] = await getPatientByIdNum(data.IDNumber);
    console.log("patientData", patientData);
    const sendData = {
      studydata: data,
      patientData: patientData.data,
    };
    const [res, err] = await writeModalityFile(sendData);
    if (res) {
      props.enqueueSnackbar(`Success : ${res.message}`, {
        preventDuplicate: true,
        variant: "success",
      });
    } else {
      console.error(err.message);
      props.enqueueSnackbar(`ERROR : ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
  };

  const handleChangeStatus = async (index) => {
    setLoading(true);
    const worklist_copy = [...worklist.filtered];
    const row = worklist_copy[index];
    const status = row.Status.toLowerCase();

    let new_status = "";

    switch (status) {
      case "waiting":
        new_status = "ARRIVED";
        break;

      case "arrived":
        new_status = "START_EXAM";
        break;

      case "start_exam":
        sendModalityFile(row);
        new_status = "QC";
        break;

      case "end_exam":
        new_status = "QC";
        break;

      case "qc":
        setCurrentProcedure({
          index: index,
          data: row,
          isFor: "QC",
        });
        break;

      case "dictate":
        setCurrentProcedure({
          index,
          data: row,
          isFor: "REPORT",
        });
        break;

      case "typist":
        setCurrentProcedure({
          index,
          data: row,
          isFor: "REPORT",
        });
        break;

      case "authorize":
        setCurrentProcedure({
          index,
          data: row,
          isFor: "REPORT",
        });
        break;

      case "done":
        setCurrentProcedure({
          index,
          data: row,
          isFor: "REPORT",
        });
        setIsDone(true);
        break;

      default:
        break;
    }

    if (
      status === "waiting" ||
      status === "arrived" ||
      status === "start_exam" ||
      status === "end_exam"
    ) {
      worklist_copy[index] = { ...row, Status: new_status };

      const [, err] = await updateStudy(worklist_copy[index]);

      if (!err) {
        setWorklist({
          list: worklist_copy,
          filtered: worklist_copy,
        });
      } else {
        console.error(err.message);
        props.enqueueSnackbar(`ERROR : ${err.message}`, {
          preventDuplicate: true,
          variant: "error",
        });
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const handleSetWorklist = (list) => {
    setWorklist({
      list: list,
      filtered: list,
    });
  };

  const handleOpenReport = () => setOpenReport(true);
  const handleCloseReport = () => {
    setOpenReport(false);
    cleanOutCurrentProcedure();
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleFilterStartDate = (val) => {
    setFilter({
      ...filter,
      date: {
        ...filter.date,
        start: val,
      },
    });
  };

  const handleFilterEndDate = (val) => {
    setFilter({
      ...filter,
      date: {
        ...filter.date,
        end: val,
      },
    });
  };

  const handleEnableEditPatient = (row, index) => {
    setCurrentProcedure({
      index: index,
      isFor: "EDIT-PATIENT",
      data: row,
    });
  };

  const handleFilterStringChange = (e) => {
    e.preventDefault();
    setFilter({
      ...filter,
      string: e.target.value,
    });
  };

  const handleFilterStatusChange = (_, statuses) => {
    setFilter({
      ...filter,
      statusValues: statuses,
    });
  };

  const getFilteredWorklist = (filterString, studies) => {
    const str = filterString.toLowerCase();
    if (!str) return studies;
    else {
      return studies.filter(
        (study) =>
          (study.LastName && study.LastName.toLowerCase().includes(str)) ||
          (study.FirstName && study.FirstName.toLowerCase().includes(str)) ||
          (study.Procedure && study.Procedure.toLowerCase().includes(str)) ||
          (study.Branch && study.Branch.toLowerCase().includes(str))
      );
    }
  };

  const getFilteredWorklistByStatus = (status, studies) => {
    return studies.filter(
      (study) =>
        study.Status && study.Status.toLowerCase() === status.toLowerCase()
    );
  };
  const displayIssues = (issues) => {
    setIssues(issues);
    setOpenIssues(true);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * ROWS_PER_PAGE - worklist.filtered.length)
      : 0;

  return (
    <>
      <Modal
        open={openIssues}
        onClose={() => setOpenIssues(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Issues
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {Issues}
          </Typography>
        </Box>
      </Modal>

      {currentProcedure.isFor === "PROCEDURE_CANCELATION" && (
        <StudyCancelationForm
          form={cancelationDetails}
          loading={loading}
          handleChange={handleCancelationDetailsChange}
          close={cleanOutCurrentProcedure}
          enqueueSnackbar={props.enqueueSnackbar}
          confirmCancelation={handleCancelProcedure}
        />
      )}

      {openReport ? (
        <Report
          worklist={worklist.list}
          procedure={currentProcedure}
          status={currentProcedure.Status}
          isDone={isDone}
          close={handleCloseReport}
          updateWorklist={handleSetWorklist}
        />
      ) : (
        <Box sx={{ width: "100%" }}>
          <SearchFilter
            handleChange={handleFilterStringChange}
            val={filter.string}
            placeholder={
              "Filter by 'First/Last Name', 'Branch', or 'Procedure' "
            }
          />

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <WorkListStatusFilter handleChange={handleFilterStatusChange} />
              </Grid>
              <Grid item xs={2}>
                <DesktopDatePicker
                  label="From"
                  inputFormat="MM/dd/yyyy"
                  value={filter.date.start}
                  onChange={handleFilterStartDate}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </Grid>

              <Grid item xs={2}>
                <DesktopDatePicker
                  label="To"
                  inputFormat="MM/dd/yyyy"
                  value={filter.date.end}
                  onChange={handleFilterEndDate}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>

          {loading ? (
            <Loader />
          ) : (
            <Paper sx={{ width: "100%", mb: 2 }}>
              <TableContainer>
                <Table sx={{ minWidth: 750 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="right"
                        style={{
                          backgroundColor: "black",
                          margin: 0,
                          padding: 0,
                        }}
                      />
                      {WORKLIST_COLUMN_PROPERTIES.map((column) => (
                        <TableCell
                          style={{ backgroundColor: "black" }}
                          key={uuidv4()}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  {/*  */}

                  <TableBody>
                    {worklist.filtered
                      .slice(
                        page * ROWS_PER_PAGE,
                        page * ROWS_PER_PAGE + ROWS_PER_PAGE
                      )
                      .map((procedure, index) => (
                        <TableRow hover key={uuidv4()}>
                          <TableCell
                            align="right"
                            style={{ margin: 0, padding: 0 }}
                          >
                            <IconButton
                              onClick={() =>
                                handleEnableEditPatient(procedure, index)
                              }
                            >
                              <MoreVertIcon color="secondary" />
                            </IconButton>
                          </TableCell>
                          <TableCell component="th" scope="procedure">
                            {procedure.IDNumber}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.Accession}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.ClaimNumber
                              ? procedure.ClaimNumber
                              : "Not set yet"}
                          </TableCell>
                          <TableCell align="left">
                            <WorklistFlag
                              flag={procedure.flag}
                              flagErrors={procedure.flagErrors}
                              displayIssues={displayIssues}
                            />
                          </TableCell>
                          <TableCell align="left">
                            {procedure.FirstName}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.LastName}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.Procedure}
                          </TableCell>
                          <TableCell align="left">
                            <Button
                              onClick={() => handleChangeStatus(index)}
                              variant="outlined"
                              size="small"
                              color={`${
                                procedure.Status.toUpperCase() === "DONE"
                                  ? "success"
                                  : "warning"
                              }`}
                              style={{ width: "130px" }}
                              disabled={procedure.Canceled}
                            >
                              {procedure.Status.toUpperCase() === "DONE"
                                ? "VIEW REPORT"
                                : procedure.Status}
                            </Button>
                          </TableCell>
                          <TableCell align="left">{procedure.Branch}</TableCell>
                          {/* <TableCell align="center">
                            {procedure.Canceled ? (
                              <Button
                                variant="outlined"
                                style={{ width: "130px" }}
                                disabled={true}
                                size="small"
                              >
                                {"Canceled"}
                              </Button>
                            ) : (
                              <IconButton
                                onClick={() =>
                                  handleStudyCancelationFormOpen(index)
                                }
                                variant="outlined"
                                color="primary"
                                title="Cancel study"
                                data-tip="Click to cancel procedure"
                              >
                                <ReactTooltip
                                  place="top"
                                  type="info"
                                  effect="solid"
                                />

                                <HighlightOffIcon color="primary" />
                              </IconButton>
                            )}
                          </TableCell> */}
                        </TableRow>
                      ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                rowsPerPageOptions={[ROWS_PER_PAGE]}
                rowsPerPage={ROWS_PER_PAGE}
                count={worklist.list.length}
                page={page}
                onPageChange={handleChangePage}
              />
            </Paper>
          )}
        </Box>
      )}

      {currentProcedure.data && currentProcedure.isFor === "QC" && (
        <QCModal
          worklist={worklist.list}
          procedure={currentProcedure}
          updateWorklist={handleSetWorklist}
          close={cleanOutCurrentProcedure}
        />
      )}

      {currentProcedure.isFor === "EDIT-PATIENT" && (
        <WorklistOptionsMenu
          procedure={currentProcedure.data}
          index={currentProcedure.index}
          close={cleanOutCurrentProcedure}
          enqueueSnackbar={props.enqueueSnackbar}
          IDNumber={currentProcedure.data.IDNumber}
          deleteProcedure={handleStudyCancelationFormOpen}
        />
      )}

      <a href="/job-card" target="_blank" id="open-job-card-trigger-btn" />
      <a href="/label" target="_blank" id="open-label-trigger-btn" />
    </>
  );
};

const WorklistOptionsMenu = (props) => {
  const history = useHistory();
  const { newPatientDispatch } = useNewPatientContext();
  const [loading, setLoading] = useState(false);
  const [currentPatient, setCurrentPatient] = useState(null);
  const [openModal, setOpenModal] = useState(true);

  useEffect(() => {
    const getCurrentUser = async () => {
      setLoading(true);
      const [res, err] = await getPatientByIdNum(props.IDNumber);
      if (res.data) {
        const user = res.data;
        setCurrentPatient(user);
        setLoading(false);
      } else {
        setLoading(false);
        setOpenModal(false);
        props.enqueueSnackbar("Error : Failed to fetch user", {
          preventDuplicate: true,
          variant: "error",
        });
      }
    };

    getCurrentUser();
  }, []);

  useEffect(() => {
    if (currentPatient) {
      newPatientDispatch(setNewPatient(currentPatient));
    }
  }, [currentPatient]);

  const handleEditPatient = () => {
    if (currentPatient) {
      localStorage.setItem("URL_PREV_ACTION", "worklist");
      history.push("/patient");
    }
  };

  const handleEditProcedure = () => {
    localStorage.setItem("current-procedure", JSON.stringify(props.procedure));
    if (currentPatient) {
      localStorage.setItem("URL_PREV_ACTION", "worklist");
      history.push("/edit-study");
    }
  };

  const handlePayRecipt = () => {
    localStorage.setItem("current-procedure", JSON.stringify(props.procedure));
    if (currentPatient) {
      localStorage.setItem("URL_PREV_ACTION", "worklist");
      history.push("/cash-payment");
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={props.close}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Grid
          container
          spacing = {2}
          justifyContent="center"
          alignItems="center"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            bgcolor: "background.paper",
            border: "2px solid #f44436",
            boxShadow: 24,
            p: 4,
            
          }}
        >
          <Grid item xs={4}>
            <Button
              variant="contained"
              startIcon={<PersonIcon />}
              onClick={handleEditProcedure}
              sx={{ minWidth: "100%", }}
            >
              {loading ? (
                <RotateSpinner size={20} color="#fff" />
              ) : (
                <>Edit Procedure</>
              )}
            </Button>
          </Grid>

          <Grid item xs={4}>
            <Button
              variant="contained"
              startIcon={<PersonIcon />}
              onClick={() => props.handleStudyCancelationFormOpen(props.index)}
              sx={{ minWidth: "100%", }}
            >
              {loading ? (
                <RotateSpinner size={20} color="#fff" />
              ) : (
                <>Delete Procedure</>
              )}
            </Button>
          </Grid>

          <Grid item xs={4}>
            <Button
              variant="contained"
              startIcon={<PersonIcon />}
              onClick={handleEditPatient}
              sx={{ minWidth: "100%", }}
            >
              {loading ? (
                <RotateSpinner size={20} color="#fff" />
              ) : (
                <>Edit Patient</>
              )}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              startIcon={<PersonIcon />}
              onClick={handlePayRecipt}
              sx={{ minWidth: "100%", }}

            >
              {loading ? (
                <RotateSpinner size={20} color="#fff" />
              ) : (
                <>Add receipt</>
              )}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              accession={props.procedure.AccessionNumber}
              startIcon={<LocalPrintshopIcon />}
              sx={{ minWidth: "100%", }}
              onClick={() => {
                const jobCardTriggerBtn = document.querySelector(
                  "#open-job-card-trigger-btn"
                );

                if (!loading && jobCardTriggerBtn) {
                  localStorage.setItem(
                    "current-procedure",
                    JSON.stringify(props.procedure)
                  );

                  localStorage.setItem(
                    "currentPatient",
                    JSON.stringify(currentPatient)
                  );

                  history.push("/job-card");
                }
              }}
            >
              {loading ? (
                <RotateSpinner size={20} color="#fff" />
              ) : (
                <>Print Job Card</>
              )}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              startIcon={<LocalPrintshopIcon />}
              style={{ minWidth: "100%" }}
              onClick={() => {
                const lableTriggerBtn = document.querySelector(
                  "#open-label-trigger-btn"
                );

                if (!loading && lableTriggerBtn) {
                  history.push("/label");
                }
              }}
            >
              {loading ? (
                <RotateSpinner size={20} color="#fff" />
              ) : (
                <>Print Label</>
              )}
            </Button>
          </Grid>
          {props.procedure.Canceled && (
            <Box
              sx={{
                width: "100%",
                background: "#000",
                border: "1px #ffa726 solid",
                marginTop: "15px",
                p: 4,
              }}
            >
              <h3 style={{ display: "flex", opacity: 0.9, color: "#ffa726" }}>
                Reason for cancellation
              </h3>

              <Typography sx={{ opacity: 0.9 }}>
                {props.procedure.CancelationReason}
              </Typography>
            </Box>
          )}
        </Grid>
        </>     
    </Modal>
  );
};

export default withSnackbar(withRouter(Worklist));
